import axios from 'axios'

export const getPhotos = ({ commit }) => {
    axios.get("https://pascaldemunckbackend.com/api/photos/")
    .then(response => {
        commit('SET_PHOTOS', response.data);
    })
}

export const getSpecie = ({ commit }) => {
    axios.get("https://pascaldemunckbackend.com/api/specie/")
    .then(response => {
        commit('SET_SPECIE', response.data);
    })
}

export const getSpeciePhoto = ({ commit }) => {
    axios.all([axios.get(`https://pascaldemunckbackend.com/api/photos/`), axios.get(`https://pascaldemunckbackend.com/api/specie/`)])
    .then(axios.spread((first, second) => {
        commit('SET_PHOTOS', first.data),
        commit('SET_SPECIE',  second.data)
    }))
}

export const getPhotoVoyage = ({ commit }) => {
    axios.get("https://pascaldemunckbackend.com/api/voyages/")
    .then(response => {
        commit('SET_VOYAGES',  response.data);
    })
}
